import { useState } from 'react';
import ConfirmDialog from '../components/ConfirmDialog';

export function useConfirm() {
    const [confirmState, setConfirmState] = useState({
        isOpen: false,
        title: '',
        message: '',
        onConfirm: () => { },
        confirmText: 'Confirm',
        confirmStyle: 'danger'
    });

    const confirm = ({ title, message, confirmText, confirmStyle = 'danger' }) => {
        return new Promise((resolve) => {
            setConfirmState({
                isOpen: true,
                title,
                message,
                confirmText,
                confirmStyle,
                onConfirm: () => resolve(true)
            });
        });
    };

    const handleClose = () => {
        setConfirmState(prev => ({ ...prev, isOpen: false }));
    };

    const ConfirmDialogComponent = () => (
        <ConfirmDialog
            {...confirmState}
            onClose={handleClose}
        />
    );

    return { confirm, ConfirmDialog: ConfirmDialogComponent };
}
